const LoadingFallback = () => <div>Carregando...</div>;

export default LoadingFallback;
